import React from 'react'
import { connect } from 'react-redux'
import UserAdmin from '../components/UserAdmin'
import { searchForUsers } from '../actions/userSearchActions'
import { fetchUser, fetchUserEvents, updateUser, updateUserAffiliations } from '../actions/userAdminActions'

/**
 * The root component of the User Admin part of the Admin Gear
 * 
 * Accepts and passes the location prop so that when the location changes, React knows to re-render UserAdminPage since React re-renders on prop change.
 * 
 * @author Alex Clary
 * 
 */
const UserAdminContainer = (props) =>
  <UserAdmin
    user={props.user}
    userId={parseInt(props.match.params.userId)}
    userAdmin={props.userAdmin}
    stationList={props.stationList}
    location={props.location}
    searchForUsers={props.searchForUsers}
    fetchUser={props.fetchUser}
    fetchUserEvents={props.fetchUserEvents}
    updateUser={props.updateUser}
    updateUserAffiliations={props.updateUserAffiliations} />

const mapStateToProps = (state, ownProps) => ({
  user: state.currentUser,
  userAdmin: state.adminState.userAdmin,
  stationList: state.profileInfo.stationList
})

const mapDispatchToProps = {
  searchForUsers,
  fetchUser,
  fetchUserEvents,
  updateUser,
  updateUserAffiliations
}

export default connect(mapStateToProps, mapDispatchToProps)(UserAdminContainer)